import { useState } from 'react'
import { PURSUIT_ORDER, ownerName } from '../../lib/championships.js'
import styles from './views.module.css'

/**
 * Crown / field-correction modal.
 *  - mode "crown": record the winner (→ api.championWrite: current_champion +
 *    sr_confirmed_date). The backend deliberately does NOT flip
 *    sr_champion_status here, so it never fires automation unexpectedly.
 *  - mode "edit": correct pursuit status + assigned rep (→ api.championUpdate).
 */
export default function CrownModal({ record, mode, onClose, onSubmit, busy, error }) {
  const [champion, setChampion] = useState(record.champion || record.winningSchool || '')
  const [confirmedDate, setConfirmedDate] = useState(
    record.dateObj ? record.dateObj.toISOString().slice(0, 10) : ''
  )
  const [pursuit, setPursuit] = useState(record.pursuit || 'Not Started')
  const [rep, setRep] = useState(() => ownerName(record))

  const isCrown = mode === 'crown'

  function submit(e) {
    e.preventDefault()
    if (isCrown) {
      onSubmit({ current_champion: champion.trim(), sr_confirmed_date: confirmedDate })
    } else {
      onSubmit({ sr_pursuit_status: pursuit, sr_assigned_rep: rep.trim() })
    }
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className={styles.modalHead}>
          <div className="eyebrow">{isCrown ? 'Crown champion' : 'Correct fields'}</div>
          <h3 className={styles.modalTitle}>{record.name}</h3>
        </div>

        <form className={styles.form} onSubmit={submit}>
          {isCrown ? (
            <>
              <label className="field-label">Champion (winning team / school)</label>
              <input
                className="input"
                value={champion}
                onChange={(e) => setChampion(e.target.value)}
                placeholder="e.g. Northgate High"
                autoFocus
              />
              <label className="field-label" style={{ marginTop: 12 }}>Confirmed date</label>
              <input className="input" type="date" value={confirmedDate} onChange={(e) => setConfirmedDate(e.target.value)} />
              <p className={styles.note}>
                Records the winner and confirms the date. The ring-artwork automation
                (<code>sr_champion_status</code>) is intentionally gated by the backend and is
                not fired from here.
              </p>
            </>
          ) : (
            <>
              <label className="field-label">Pursuit status</label>
              <select className="input" value={pursuit} onChange={(e) => setPursuit(e.target.value)}>
                {PURSUIT_ORDER.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
              <label className="field-label" style={{ marginTop: 12 }}>Assigned rep</label>
              <input className="input" value={rep} onChange={(e) => setRep(e.target.value)} placeholder="Rep name" />
            </>
          )}

          {error && <p className={styles.errorMsg}>{error}</p>}

          <div className={styles.modalActions}>
            <button type="button" className="btn" onClick={onClose} disabled={busy}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={busy || (isCrown && !champion.trim())}>
              {busy ? <span className="spinner" /> : isCrown ? 'Crown champion' : 'Save changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
